import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { IconSize } from '../../core-data-model/IconSize';
import { IconType } from '../../core-data-model/IconType';
import { PeekService } from './Peek.service';

@Component({
    selector: 'peek-root',
    host: {
        '[class.dontShow]': '!open'
    },
    queries: {
        asideRef: new ViewChild('asideRef')
    },
    template: `
        <div class="peekBackdrop" (click)="close()"></div>
        <!-- Clicking on this should close the peek panel-->
        <aside
            #asideRef
            class="peek"
            [ngClass]="{
                peeking: open,
                'peek-no-scroll': noScroll
            }"
            piTesting="aside"
        >
            <a
                class="peekClose"
                href="javascript:;"
                (click)="close()"
                piTesting="peek-close"
            >
                <abstract-icon
                    [iconType]="IconType.Close"
                    [iconSize]="IconSize.M_large"
                >
                </abstract-icon>
            </a>
            <div class="peekContent">
                <ng-template [ngTemplateOutlet]="peekService.templateRef">
                </ng-template>
            </div>
        </aside>
    `,
    standalone: false
})
export class PeekRootComponent implements OnDestroy {
    IconType = IconType;
    IconSize = IconSize;

    subscription: Subscription;
    open = false;

    noScrollSubscription: Subscription;
    noScroll = false;

    resetScrollToTopSubscription: Subscription;
    resetScrollToTop = false;

    showScrollBarSubscription: Subscription;
    showScrollBar = false;

    public asideRef: ElementRef;

    constructor(public peekService: PeekService) {
        this.subscription = this.peekService.open$.subscribe(
            (isOpen) => (this.open = isOpen)
        );

        this.noScrollSubscription = this.peekService.noScroll$.subscribe({
            next: (noScroll) => (this.noScroll = noScroll)
        });

        this.resetScrollToTopSubscription =
            this.peekService.resetScrollToTop$.subscribe({
                next: (resetScrollToTop) =>
                    (this.resetScrollToTop = resetScrollToTop)
            });

        this.showScrollBarSubscription =
            this.peekService.showScrollBar$.subscribe({
                next: (showScrollBar) => (this.showScrollBar = showScrollBar)
            });
    }

    close() {
        this.peekService.setOpen(false);

        // on close reset the peek panel to top of panel content
        if (this.resetScrollToTop) {
            this.asideRef.nativeElement.scroll(0, 0);
        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.noScrollSubscription.unsubscribe();
        this.resetScrollToTopSubscription.unsubscribe();
        this.showScrollBarSubscription.unsubscribe();
    }
}
